module.exports = {
  "version": "0.33.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 170
// module chunks = 1